// utils/getField.js
export const getTranslatedField = (translatedData, localData, key) => {
  const translated = translatedData?.[key];
  console.log("translatedtranslated", translated);
  console.log("localDatalocalData", localData);
  return translated && translated.trim() !== "" ? translated : localData?.[key];
};
